/**
 * Log client-side errors to the server
 */

'use strict';

var $ = require('jquery');
var historyModel = require('./historyModel');

// max number of errors logged per session
var MAX_ERRORS = 2;

// error count
var errors = 0;

/**
 * post the messages to the server
 */
function log(url, message, file, line, column, error) {
	$.post(url, {
		message: message,
		href: window.location.href,
		file: file,
		line: line,
		column: column,
		stack: error ? error.stack : '',
		history: historyModel.getPath(),
		userAgent: navigator.userAgent
	});
}

/**
 * start capturing global errors
 * @param URL where we POST the errors
 */
function start(url) {

	window.onerror = function(message, file, line, column, errpr) {

		// avoid spamming the service if there are a lot of errors
		if (errors > MAX_ERRORS) {
			return;
		}

		errors++;

		// log the messages to the server
		log(url, message, file, line, column, errpr);
	};
}

module.exports = {
	start: start,
	log: log
};


//////////////////
// WEBPACK FOOTER
// ./components/consumerweb-client-error-logger/error.js
// module id = 869
// module chunks = 0